import $ from "jquery";
$(".shapes-four .shape, .shape").each(function (i) {
  $(this).wrap("<div class='shape-container'></div>");
  $(this).wrapInner("<div class='content'></div>");

  var topdir = 0,
    bottomdir = 0,
    rightdir = 0,
    leftdir = 0;

  topdir = $(this).data("top-dir");
  bottomdir = $(this).data("bottom-dir");
  rightdir = $(this).data("right-dir");
  leftdir = $(this).data("left-dir");

  if (topdir) {
    var topdeg = $(this).data("top-deg");
    if (bottomdir != 0) {
      if (topdir === "rtl") {
        $(this).parent().css("transform-origin", "100% 0%");
        $(this)
          .parent()
          .css("transform", "skewY(-" + topdeg + "deg)");
        $(this)
          .find(".content")
          .css("transform", "skewY(-" + topdeg + "deg)");
      } else {
        // console.log($(this).attr('id'));
        $(this).css("transform-origin", "0% 100%");
        $(this).css("transform", "skewY(" + topdeg + "deg)");
        $(this)
          .find(".content")
          .css("transform", "skewY(-" + topdeg + "deg)");
      }
    } else {
      if (topdir === "rtl") {
        $(this).css("transform-origin", "100% 0%");
        $(this).css("transform", "skewY(-" + topdeg + "deg)");
        $(this)
          .find(".content")
          .css("transform", "skewY(" + topdeg + "deg)");
      } else {
        $(this).css("transform-origin", "0% 100%");
        $(this).css("transform", "skewY(" + topdeg + "deg)");
        $(this)
          .find(".content")
          .css("transform", "skewY(-" + topdeg + "deg)");
      }
    }
  }

  if (bottomdir) {
    var bottomdeg = $(this).data("bottom-deg");
    if (topdir) {
      if (topdir === bottomdir) {
        bottomdeg = bottomdeg * 2;
        bottomSlant($(this), bottomdir, bottomdeg, topdir);
      } else {
        resizeshape($(this));
      }
    } else {
      bottomSlant($(this), bottomdir, bottomdeg, topdir);
    }
  }

  if (rightdir != 0) {
    var rightdeg = $(this).data("right-deg");
    if (leftdir != "") {
      if (rightdir === "ttb") {
        $(this).parent().css("transform-origin", "100% 0%");
        $(this)
          .parent()
          .css("transform", "skewX(-" + rightdeg + "deg)");
        // $(this).find('.content').css('transform', 'skewX('+rightdeg+'deg)');
        var contentTransform = $(this).find(".content").css("transform");
        contentTransform += "skewX(" + rightdeg + "deg)";
        $(this).find(".content").css("transform", contentTransform);
      } else {
        $(this).parent().css("transform-origin", "0% 100%");
        $(this)
          .parent()
          .css("transform", "skewX(" + rightdeg + "deg)");
        // $(this).find('.content').css('transform', 'skewX(-'+rightdeg+'deg)');
        var contentTransform = $(this).find(".content").css("transform");
        contentTransform += "skewX(-" + rightdeg + "deg)";
        $(this).find(".content").css("transform", contentTransform);
      }
    } else {
      if (rightdir === "ttb") {
        $(this).css("transform-origin", "100% 0%");
        $(this).css("transform", "skewX(-" + rightdeg + "deg)");
        var contentTransform = $(this).find(".content").css("transform");
        contentTransform += "skewX(" + rightdeg + "deg)";
        $(this).find(".content").css("transform", contentTransform);
      } else {
        $(this).css("transform-origin", "100% 100%");
        $(this).css("transform", "skewX(" + rightdeg + "deg)");
        // $(this).find('.content').css('transform', 'skewX(-'+rightdeg+'deg)');
        var contentTransform = $(this).find(".content").css("transform");
        contentTransform += "skewX(-" + rightdeg + "deg)";
        $(this).find(".content").css("transform", contentTransform);
      }
    }
  }

  if (leftdir != "" && leftdir != 0 && leftdir != undefined) {
    var leftdeg = $(this).data("left-deg");

    if (rightdir != "" && rightdir != undefined) {
      if (rightdir === leftdir) {
        leftdeg = leftdeg * 2;
        leftSlant($(this), leftdir, leftdeg);
      } else {
        // resizeshape($(this));
      }
    } else {
      leftSlant($(this), leftdir, leftdeg);
    }
  }

  if (rightdir != "" && rightdir != 0 && rightdir != undefined) {
    var rightdeg = $(this).data("right-deg");
    if (leftdir != "") {
      if (rightdir === leftdir) {
        rightdeg = rightdeg * 2;
        // rightSlant($(this),rightdir,rightdeg);
      } else {
        // resizeshape($(this));
      }
    } else {
      // rightSlant($(this),rightdir,rightdeg);
    }
  }
});

function bottomSlant(that, bottomdir, bottomdeg, topdir) {
  if (bottomdir === "rtl") {
    $(that).css("transform-origin", "100% 100%");
    $(that).css("transform", "skewY(" + bottomdeg + "deg)");
    if (topdir == undefined) {
      $(that)
        .find(".content")
        .css("transform", "skewY(-" + bottomdeg + "deg)");
    }
  } else {
    $(that).css("transform-origin", "0% 100%");
    $(that).css("transform", "skewY(-" + bottomdeg + "deg)");
    if (topdir == undefined) {
      $(that)
        .find(".content")
        .css("transform", "skewY(" + bottomdeg + "deg)");
    }
  }
}

function leftSlant(that, leftdir, leftdeg) {
  var transform = "";
  transform = $(that).css("transform");
  if (!transform) {
    transform = $(that).parent().css("transform");
  }
  if (leftdir == "ttb") {
    transform += " skewX(" + leftdeg + "deg)";
    $(that).css("transform", transform);
    $(that).css("transform-origin", "0% 0%");
  } else {
    transform += " skewX(-" + leftdeg + "deg)";
    $(that).css("transform", transform);
    $(that).css("transform-origin", "100% 100%");
  }
}

function rightSlant(that, rightdir, rightdeg) {
  var transform = "";
  var parent = 0;
  transform = $(that).css("transform");
  if (!transform) {
    var parent = 1;
    transform = $(that).parent().css("transform");
  }
  if (rightdir == "ttb") {
    transform += " skewX(-" + rightdeg + "deg)";
    if (parent == 1) {
      $(that).parent().css("transform", transform);
      $(that).parent().css("transform-origin", "0% 0%");
    } else {
      $(that).css("transform", transform);
      // $(that).css('transform-origin', '0% 0%');
    }
  } else {
    transform += " skewX(" + rightdeg + "deg)";
    $(that).css("transform", transform);
    $(that).css("transform-origin", "100% 100%");
  }
}

function resizeshape(that) {
  var parentHeight = $(that).parent().height();
  var parentWidth = $(that).parent().width();
  var degrees = $(that).data("top-deg");
  var radians = (degrees * Math.PI) / 180;
  var newHeight = parentWidth * Math.tan(radians);
  var newOffset = newHeight / 2;
  var newParentHeight = parentHeight + newHeight;
  var topOffset = newParentHeight - parentHeight;
  // $(that).parent().css('top', ''+topOffset+'px');
  $(that)
    .parent()
    .css("height", parentHeight - topOffset + "px");
  // console.log(parentHeight - topOffset);
}
